import CxTableMixin from '@/mixins/CxTableMixin';
import ContextMenuMixin from '@/mixins/jlr/JlrContextMenuMixin';
import moment from "moment";

export default {
  mixins: [ CxTableMixin, ContextMenuMixin ],

  data() {
    return {
      columnDefs: [
        { 
          cellRenderer: 'linkCellRenderer',
          field: "CountryId",
          filter: false,
          headerName: "Details",
          hidden: true,
          lockPosition: 'left',
          lockVisible: true,
          pinned: 'left',
          sortable: false,
          width: 100
        }, { 
          cellStyle: this.leftCellStyle,
          field: "CountryName",
          filter: 'agSetColumnFilter',
          headerName: "Country",
          hidden: true,
          minWidth: 150,
          pinned: 'left',
          lockPosition: 'left',
          lockVisible: true,
          suppressMenu: true,
          width: 200
        }, { 
          autoHeight: true,
          cellRenderer: 'flagCellRenderer',
          headerName: "",
          hidden: true,
          field: "CountryId",
          filter: false,
          lockPinned: true,
          pinned: true,
          lockPosition: 'left',
          lockVisible: true,
          pinned: 'left',
          sortable: false,
          width: 80
        }
      ],

      defaultColDef: {
        width: 170,
        lockPosition: true,
        suppressMovable: true,
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        suppressMovable: true,
        enableRowGroup: false,
        cellStyle: {'text-align': 'center', 'text-align': '-webkit-center', 'font-weight': 500, 'font-size': '15px' },
        menuTabs: ['generalMenuTab', 'filterMenuTab']
      },

      leftCellStyle: { 'text-align': 'left', 'text-align': '-webkit-left', 'font-weight': 500, 'font-size': '15px' },

      gridApi: null,

      gridColumnApi: null,

      gridOptions: { 
        domLayout: 'autoHeight',
        suppressAggFuncInHeader: true,
        groupDisplayType: 'custom',
        animateRows: true,
        suppressExcelExport: false,
        suppressContextMenu: true,
        onGridReady: (event) => {
          event.columnApi.autoSizeAllColumns()

          this.gridApi = event.api;
          this.gridColumnApi = event.columnApi;
        },
        defaultExcelExportParams: this.getExcelSettings(),
      },
      
      // Inject rows into CustomDataGrid
      rowData: [],

      // pinned to the top
      pinnedTopRowData: []
    }
  }
}
